import React, { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { useDispatch } from "react-redux";
import { getBannerList } from "../actions/offerBannerAction";
import { useNavigate } from "react-router-dom";
import { openInNewTab } from "../helpers/commonHelper";
import { setSearchPayload } from "../actions/flightAction";
import { PLAIN_SEARCH_FORM } from "../reducers/types";

function Offer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [bannerlist, setBannerList] = useState(null);
  useEffect(() => {
    dispatch(
      getBannerList((list) => {
        setBannerList(list);
      })
    );
  }, []);
  const handleSearchInventoryFlight = (info) => {
    let e = {
      "from": info.Origin,
      "to": info.Destination,
      "departure": info.DepartureDate,
      "return": info.ReturnDate,
      "noOfPassenger": 1,
      "child": 0,
      "infant": 0,
      "cabinClass": "Y",
      "tripType": "1",
      "nationality": "NP",
      "offerId": info.ManualInventoryId,
      "fareType": "1"
    }
    var strPath = new URLSearchParams(e).toString();
    navigate({ pathname: "/flights", search: strPath });
  }
  return (
    bannerlist &&
    bannerlist.length > 0 && (
      <div className="bg-background dark:bg-background">
        <div className="container py-6 lg:py-20 px-0">
          <div className="flex items-end justify-between gap-4 mb-4">
            <div>
              <h2 className="text-lg md:text-xl font-semibold tracking-tight">
                Best Fare Deals
              </h2>
              <p className="text-sm text-muted-foreground">
                Here are some of the best fare deals for you.
              </p>
            </div>
          </div>

          <Carousel
            opts={{
              align: "start",
              dragFree: true,
            }}
            className="w-full px-10"
          >
            <CarouselContent >
              {bannerlist.map((_, index) => (
                <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                  <Card className="h-full">
                    <CardContent
                      className="p-0 cursor-pointer"
                      onClick={() => {
                        if (_.ManualInventoryId == 0)
                          openInNewTab(_.DetailUrl);
                        else handleSearchInventoryFlight(_);
                      }}
                      target="_blank"
                    >
                      <div className="flex flex-col">
                        <div className="flex-1 flex items-center justify-center">
                          <img
                            className="mb-3"
                            src={`${_.ImageUrl}`}
                            alt=""
                          />
                        </div>
                        <div className="p-6">
                          <p>{_.Title}</p>
                          <p className="font-semibold">{_.Description}</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="absolute left-0 z-20" />
            <CarouselNext className="absolute right-0 z-20" />
          </Carousel>
        </div>
      </div>
    )
  );
}

export default Offer;
